import React from 'react';

import styled from 'styled-components';

const StyledDiv = styled.div`
    display: flex;
    justify-content: ${(props) => props.justify || 'space-between'};
    align-items: ${(props) => props.align || 'flex-start'};
    margin: ${(props) => props.margin};
    flex-wrap: wrap;
    padding: 0.5em;
`;

const NwButtonBar = ({ justify = 'space-between', margin = '.25em', align, children }) => {
    return (
        <StyledDiv justify={justify} margin={margin} align={align}>
            {children}
        </StyledDiv>
    );
};

export default NwButtonBar;
